const ItemListWrapper = () =>
  import(/* webpackChunkName: "dishes-list" */ './pages/item-list-wrapper')
const ItemSearchWrapper = () =>
  import(/* webpackChunkName: "dishes-search" */ './pages/item-search-wrapper')
const ItemStockEdit = () =>
  import(/* webpackChunkName: "item-stock-edit" */ './pages/item-stock-edit')

export default [
  { path: '/item/list', component: ItemListWrapper },
  {
    path: '/item/search/list',
    component: ItemSearchWrapper,
    name: 'itemSearchList',
  },
  { path: '/item/soldout', component: ItemSearchWrapper },
  {
    path: '/item/stock/edit',
    component: ItemStockEdit,
    name: 'itemStockEdit',
  },
]
